"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var bip39_1 = tslib_1.__importDefault(require("bip39"));

var hdkey_1 = tslib_1.__importDefault(require("hdkey"));

var address_1 = require("../address");

var account_1 = require("../eth-lib/account");

var send_tx_1 = require("../eth/send-tx");

var utils_1 = require("../utils");

var sign_1 = require("../utils/sign");

var sign_transaction_1 = require("./sign-transaction");

var Account = /*#__PURE__*/function () {
  function Account(address, privateKey, publicKey) {
    _classCallCheck(this, Account);

    this.address = address;
    this.privateKey = privateKey;
    this.publicKey = publicKey;
  }

  _createClass(Account, [{
    key: "sendTransaction",
    value: function sendTransaction(tx, eth) {
      var _this = this;

      var promise = new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var signedTx;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return sign_transaction_1.signTransaction(tx, _this.privateKey, eth);

                case 3:
                  signedTx = _context.sent;
                  _context.t0 = resolve;
                  _context.next = 7;
                  return eth.sendSignedTransaction(signedTx.rawTransaction).getTxHash();

                case 7:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t2 = _context["catch"](0);
                  reject(_context.t2);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      return new send_tx_1.SentTransaction(eth, promise);
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(tx, eth) {
      return sign_transaction_1.signTransaction(tx, this.privateKey, eth);
    }
  }, {
    key: "sign",
    value: function sign(data) {
      return sign_1.sign(data, this.privateKey);
    }
  }, {
    key: "encrypt",
    value: function encrypt(password, options) {
      return utils_1.encrypt(this.privateKey, this.address, password, options);
    }
  }], [{
    key: "create",
    value: function create() {
      var entropy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : utils_1.randomBuffer(32);

      var _account_1$create = account_1.create(entropy),
          privateKey = _account_1$create.privateKey,
          address = _account_1$create.address,
          publicKey = _account_1$create.publicKey;

      return new Account(address_1.Address.fromString(address), privateKey, publicKey);
    }
  }, {
    key: "fromPrivate",
    value: function fromPrivate(privateKey) {
      var _account_1$fromPrivat = account_1.fromPrivate(privateKey),
          address = _account_1$fromPrivat.address,
          publicKey = _account_1$fromPrivat.publicKey;

      return new Account(address_1.Address.fromString(address), privateKey, publicKey);
    }
  }, {
    key: "createFromMnemonicAndPath",
    value: function createFromMnemonicAndPath(mnemonic, derivationPath) {
      var seed = bip39_1.default.mnemonicToSeed(mnemonic);
      return Account.createFromSeedAndPath(seed, derivationPath);
    }
  }, {
    key: "createFromSeedAndPath",
    value: function createFromSeedAndPath(seed, derivationPath) {
      var root = hdkey_1.default.fromMasterSeed(seed);
      var addrNode = root.derive(derivationPath);
      var privateKey = addrNode.privateKey;
      return Account.fromPrivate(privateKey);
    }
  }, {
    key: "fromKeystore",
    value: function () {
      var _fromKeystore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(v3Keystore, password) {
        var nonStrict,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                nonStrict = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                _context2.t0 = Account;
                _context2.next = 4;
                return utils_1.decrypt(v3Keystore, password, nonStrict);

              case 4:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", _context2.t0.fromPrivate.call(_context2.t0, _context2.t1));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fromKeystore(_x3, _x4) {
        return _fromKeystore.apply(this, arguments);
      }

      return fromKeystore;
    }()
  }]);

  return Account;
}();

exports.Account = Account;